"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoutes = void 0;
const react_router_dom_1 = require("react-router-dom");
const createRoutes = (routerParent, routerPaths) => {
    const getFullRouteUrl = (value, options) => {
        return routerPaths[value];
    };
    const getRoutePath = (value) => {
        return routerPaths[value];
    };
    const getAbsoluteRoutePath = (value, options) => {
        const absoluteUrl = getFullParametricRoutePath(value);
        return "/" + (0, react_router_dom_1.generatePath)(absoluteUrl, options);
    };
    const getFullParametricRoutePath = (value) => {
        const routePath = getRoutePath(value);
        const routeParent = routerParent[value];
        if (!routeParent || routeParent == value)
            return routePath;
        return getFullParametricRoutePath(routeParent) + "/" + routePath;
    };
    return {
        getAbsoluteRoutePath
    };
};
exports.createRoutes = createRoutes;
